export const environment = {
    production: false,
   apiUrl: 'https://uat.thetorna.com/api/', //i2k2 dev environment.
    // apiUrl: 'http://localhost:8444/', 
    // authApiUrl: 'http://localhost:8443/cognito/',
    authApiUrl: 'https://uat.thetorna.com/cognito/', //i2k2 dev environment

    appVersion: '1.0.0',
    enableDebug: true,
    divisionsToProcessImmediately: '100,300', // Germany/Netherlands etc. (comma-separated string)
    divisionsToProcessAfterCutover: '400', // Other divisions (comma-separated string)
    allowEditingAfterInvoicing: false,
    HeartBeatinterval: 60000,
    defualtOrderType: 'NT1',
  defaultOrderTypesGermany: ['G10', 'G11']  ,
  defaultOrderTypesForFrance: ['F10', 'F11','FT1','FT2'] ,
  negativeQtyAllowedDivisions: ['400'], // Divisions where negative quantity is allowed
  creditLimitWarningDivisions: '100,300,400', // Divisions where credit-limit warning/check is enabled
  /**
   * Feature flag: write M3 customer block (BLCD=2) when a salesperson is hard-blocked on Sync.
   *
   * What it controls
   * - true: on CL3 (amount) and/or CL4 (overdue days) hard-block, the UI calls
   *   POST /financial/set-customer-credit-block?cuno=&cono=&divi=
   *   which runs CRS610MI/ChgFinancial and sets the customer's BLCD to 2 in M3.
   *   Later Sync is blocked by the BLCD check until a listed approver approves credit
   *   (POST credit-limit-approve clears BLCD=2 back to 0 in M3), then Sync proceeds.
   * - false: never call that API. Credit-limit dialogs still show; only the M3 BLCD write is skipped.
   *
   * Who it applies to
   * - Normal salespeople on divisions in creditLimitWarningDivisions (100, 300, 400).
   * - Not called for listed creditLimitSoftBypassSyncEmails users, already-approved orders,
   *   or orders already synced to M3 (referenceOrderId present).
   *
   * When it fires
   * - Order-list Sync, item-details Continue to Invoice (sync), preview Sync to M3 / Confirm & Invoice.
   * - Not on draft save, picklist, or generateOutput / preview load.
   *
   * Rebuild/restart the UI after changing this value.
   */
  enableCustomerCreditBlock: true,
  /** UAT/dev: full access - warn+Continue on picklist and sync. Unsuffixed keys are 300 fallback. */
  creditLimitSoftBypassPicklistEmails: 'omkarn@ssktech.co.in,monaliz@ssktech.co.in',
  creditLimitSoftBypassSyncEmails: 'omkarn@ssktech.co.in,monaliz@ssktech.co.in',
  creditLimitBypassContactPicklist: 'omkarn@ssktech.co.in,monaliz@ssktech.co.in',
  creditLimitBypassContactSync: 'omkarn@ssktech.co.in,monaliz@ssktech.co.in',
  creditLimitSoftBypassPicklistEmails_100: 'nandinid@ssktech.co.in,omkarn@ssktech.co.in',
  creditLimitSoftBypassSyncEmails_100: 'nandinid@ssktech.co.in,omkarn@ssktech.co.in',
  creditLimitBypassContactPicklist_100: 'nandinid@ssktech.co.in,omkarn@ssktech.co.in',
  creditLimitBypassContactSync_100: 'nandinid@ssktech.co.in,omkarn@ssktech.co.in',
  creditLimitSoftBypassPicklistEmails_300: 'omkarn@ssktech.co.in,monaliz@ssktech.co.in',
  creditLimitSoftBypassSyncEmails_300: 'omkarn@ssktech.co.in,monaliz@ssktech.co.in',
  creditLimitBypassContactPicklist_300: 'omkarn@ssktech.co.in,monaliz@ssktech.co.in',
  creditLimitBypassContactSync_300: 'omkarn@ssktech.co.in,monaliz@ssktech.co.in',
  creditLimitSoftBypassPicklistEmails_400: 'nandinid@ssktech.co.in,omkarn@ssktech.co.in',
  creditLimitSoftBypassSyncEmails_400: 'nandinid@ssktech.co.in,omkarn@ssktech.co.in',
  creditLimitBypassContactPicklist_400: 'nandinid@ssktech.co.in,omkarn@ssktech.co.in',
  creditLimitBypassContactSync_400: 'nandinid@ssktech.co.in,omkarn@ssktech.co.in',
  /** Div 100/400: Margin/MCM columns visible to all users; div 300: columns visible to marginApprovalEmails_* only. Emails also gate sync/proceed approval. */
  marginApprovalDivisions: '100,300,400',
  /** Divisions where Orders1 may scope by warehouse when WH is in orderListWarehouseScopedWhs_* below. */
  orderListWarehouseFilterDivisions: '100',
  /** Div 100: only these WHs filter Orders1 to own WH; 101/110 see division-wide. */
  orderListWarehouseScopedWhs_100: '130',
  /** Orders1: show Delivery # search (M3 DLIX → Torna). Comma-separated divisions. */
  deliverySearchEnabledDivisions: '300',
  marginApprovalEmails_100_101: 'rasikas@ssktech.co.in,nandinid@ssktech.co.in,omkarn@ssktech.co.in',
  marginApprovalEmails_300: 'omkarn@ssktech.co.in',
  marginApprovalEmails_400: 'omkarn@ssktech.co.in',
  marginBypassContact_100_101: 'rasikas@ssktech.co.in,nandinid@ssktech.co.in,omkarn@ssktech.co.in',
  marginBypassContact_300: 'omkarn@ssktech.co.in',
  marginBypassContact_400: 'omkarn@ssktech.co.in',
  /** Divisions allowed to use Item Details V2 (Germany go-live). */
  itemDetailsV2Divisions: ['100', '300', '400'],
  /** Default version when V2 is allowed and no user preference is saved. */
  defaultItemDetailsVersion: 'v2',
    /** Gate post-sync Edit Prices / Update Prices (M3 UpdPriceInfo) in item-details-v2. */
    enableM3PriceUpdate: true,
    /** UI deploy version check - prod only: poll + tab focus. Dev/UAT: login only. */
    enableVersionMonitoring: false,
    versionCheckOnLoginOnly: true,
    versionCheckIntervalMs: 10 * 60 * 1000,
    /** Item Details V2: ML recommendations panel (requires backend predictions.serving.enabled). */
    predictionsRecommendationsEnabled: true,
    /** Comma-separated emails allowed to open Recommendations audit dashboard. Empty = nobody. */
    recommendationsAuditAllowedEmails: 'omkarn@ssktech.co.in,swaroopb@ssktech.co.in'
 };
